<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :payroll="payroll" />
    </div>
    <div class="main-content">
      <div class="quickpay">
        <div>
          <p>You Are Ready To Run Payroll</p>

          <div class="quickpay__alert">
            <div class="quickpay__alert--img">
              <img src="./../../../assets/images/warning.png" alt />
            </div>
            <div class="quickpay__alert--text">
              All employee details have been extracted and updated. Please
              verify and proceed to pay.
            </div>
          </div>
          <div class="quickpay__table">
            <div class="quickpay__table--header">
              <div>S/N</div>
              <div>Employee Name</div>
              <div>Bank</div>
              <div>Account Number</div>
              <div>Net Pay</div>
              <div>Description</div>
            </div>
            <div class="quickpay__table--body">
              <div v-for="(employee, index) in employees" v-bind:key="employee.index">
                <div>{{ index + 1 }}</div>
                <div>{{ employee.employee_name }}</div>
                <div>{{ employee.bank_name }}</div>
                <div>{{ employee.account_number }}</div>
                <div>₦{{ employee.net_pay }}</div>
                <div>{{ employee.description }}</div>
              </div>
            </div>

            <div class="quickpay__summary__info">
              <div class="payroll__preview--warning">
                <div class="payroll__breakdown--alert-text-icon">
                  <img src="./../../../assets/images/info.png" alt />
                </div>
                <div class="payroll__breakdown--alert-text-para">
                  <div class="quickpay__summary">
                    <div class="quickpay__summary__item">
                      <span class="quickpay__summary__title">Payroll Amount:
                      </span>
                      <span class="quickpay__summary__value">&#8358;{{
        previewData.total_payroll
      }}</span>
                    </div>
                    <div class="quickpay__summary__item">
                      <span class="quickpay__summary__title">Transaction Cost:
                      </span>
                      <span class="quickpay__summary__value">&#8358;{{ transactionCost }} per Transaction</span>
                    </div>
                    <div class="quickpay__summary__item">
                      <span class="quickpay__summary__title">Transaction Amount:
                      </span>
                      <span class="quickpay__summary__value">&#8358;{{ transactionCost }} X {{ employees.length }} =
                        &#8358;{{ transactionCost * employees.length }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="quickpay__total">
                <p class="quickpay__total--text">
                  Total Deductible:
                  <span class="quickpay__total--amount">
                    &#8358;{{ previewData.total_payroll + (transactionCost * employees.length) | addKoboToValue }}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="quickpay__btns">
            <div class="quickpay__btns--proceed" @click="saveToPreview">
              Confirm & Proceed to Pay
            </div>
            <div class="quickpay__btns--cancel">
              <router-link to="/onetime-upload">
                <div>Cancel</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import { addKoboToValue } from "../../../util/filters";

export default {
  name: "OnetimePreview",
  components: {
    Header,
    Sidebar,
  },
  data() {
    return {
      item: "quick",
      payroll: "payroll",
      previewData: "",
      employees: [],
      transactionCost: 0
    };
  },
  methods: {
    saveToPreview() {
      this.$router.push("/onetime-wallet");
    },
  },
  created() {
    if (Object.keys(this.$store.state.onetime).length !== 0) {
      this.previewData = this.$store.state.onetime;
      this.transactionCost = this.previewData.transaction_cost.cost
      console.log(this.previewData);
      this.employees = [...this.previewData.payrolls];
      return;
    }
    this.$router.push("/onetime-upload");
  },
  filters: {
    addKoboToValue,
  },
};
</script>

<style lang="scss" scoped>
.quickpay__summary__info {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 3rem;
}

.payroll__preview--warning {
  border-radius: 3px;
  /* -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16); */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  border: solid 2px #a4caee;
  background-color: #5099dd33;
  padding: 12px 1.615vw;
  width: 52%;
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;

  }

  .payroll__breakdown--alert-text-icon {
    width: 2.396vw;
    float: left;
  }

  .payroll__breakdown--alert-text-para {
    width: calc(100% - 2.396vw);
    padding-left: 1.042vw;
    float: left;
    font-size: 0.8rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.22;
    letter-spacing: normal;
    text-align: left;
    color: #5099de;
  }
}

.quickpay {
  padding-top: 50px;
  padding-bottom: 100px;
  padding-left: 50px;
  padding-right: 50px;

  >p {
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: left;

    >a {
      color: #707070;
      text-decoration: none;
    }
  }

  >div {
    >p {
      font-size: 25px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    >.quickpay__alert {
      max-width: 600px;
      margin: 30px auto 50px auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 #fff9f0;
      border: solid 2px #ffe7bd;
      background-color: #fff9f0;
      padding: 10px 30px;

      >.quickpay__alert--img {
        width: 50px;
        height: 40px;

        >img {
          width: 40px;
        }
      }

      >.quickpay__alert--text {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }
    }

    >.quickpay__table {
      max-width: 100rem;
      margin: auto;

      @media (max-width: 768px) {
        overflow-x: scroll;

      }

      >.quickpay__table--header {
        height: 3rem;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        padding: 0 1rem;

        >div {
          font-size: 1rem;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      >.quickpay__table--body {
        border-top: 5px solid #5099de;

        >div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          padding: 0 1rem;
          height: 4rem;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          margin-bottom: 15px;

          >div {
            font-size: 1rem;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }
        }
      }
    }

    .quickpay__total {
      display: flex;

      .quickpay__total--text {
        font-size: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.17;
        letter-spacing: normal;
        color: #5099de;
        text-align: end;
        margin: 0;
      }

      .quickpay__total--amount {
        font-size: 25px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #000000;
      }
    }

    .quickpay__btns {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      align-content: center;
      width: 320px;
      margin: auto;
      margin-top: 40px;

      .quickpay__btns--proceed {
        width: 200px;
        border-radius: 3px;
        background-color: #5099de;
        border: 1px solid #5099de;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        padding: 12px 0;
        cursor: pointer;
      }

      .quickpay__btns--cancel {
        width: 100px;
        border-radius: 3px;
        border: solid 1px #c7c7c7;
        background-color: #ffffff;

        a {
          color: #777777;
          text-decoration: none;

          div {
            width: 100%;
            padding: 12px 0;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
          }
        }
      }
    }
  }
}

.main-content {
  display: flex;
  // height: 100vh;
  // overflow: hidden;

  .side-nav {
    width: 14rem;
    height: 100vh;
    margin-top: 7rem;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;

  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

  }
}
</style>